import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ViewProcessOrdersButton = () => {
  const { t } = useTranslation();

  // const columnData = useSelector<DynamicObjectType>(
  //   (state) => state[model].data[record.id],
  // );

  return (
    <Link to={`/inventory/inProcessOrders`}>
      <Button type="primary">{t('inProcessOrders.orderInProcess')}</Button>
    </Link>
  );
};

export default ViewProcessOrdersButton;
